import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import type { PercentageCheckFilters } from '../types/PercentageCheck';

export function usePercentageCheck(filters: PercentageCheckFilters) {
  return useQuery(allocationQueries.percentageCheck(filters));
}
